<template>
	<v-card class="connect_profile pa-3 px-10" height="500">
		<v-row no-gutters justify="center">
			<v-col cols="12" class="text-center my-6">
				<h1 class="big">{{ title }}</h1>
				<v-autocomplete
					ref="searchApp"
					hide-details
					single-line
					:menu-props="menuProps"
					:search-input.sync="searchString"
					:items="appsEntries"
					item-text="service_name"
					item-value="id"
					color="#5C8DF5"
					height="52"
					class="ac mt-6 mb-2"
					outlined
					label="Search for an app"
				>
					<template v-slot:prepend-inner>
						<div class="mx-2 s_ic">
							<SIcon name="autocomplete-search" />
						</div>
					</template>
					<template v-slot:append>
						<span></span>
					</template>
				</v-autocomplete>
			</v-col>

			<div style="width: 100%; overflow: hidden">
				<v-row no-gutters>
					<v-col cols="12" v-for="item in filteredItems" :key="item.id" class="mb-2 result_block" @click="selectApp(item)">
						<v-row no-gutters align="center">
							<v-col class="text-left" cols="auto">
								<v-card class="ac_card inline-block">
									<div class="centerdXY">
										<SIcon :width="22" :name="item.service_slug" />
									</div>
								</v-card>
							</v-col>
							<v-col class="pl-3 text-left">
								<h3>
									{{ item.service_name }}
								</h3>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</div>
		</v-row>
	</v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import AppService from '@/utils/AppService';
export default {
	name: 'ServiceSelector',
	props: {
		title: { type: String },
	},
	computed: {
		...mapGetters(['apps/getAllServicesList']),
		menuProps() {
			return { maxHeight: 0 };
		},
		appsEntries() {
			return this['apps/getAllServicesList'];
		},
		filteredItems() {
			return this.appsEntries.filter(
				(app) => AppService.doesRequiresAuth(app) && app.service_name.toLowerCase().includes((this.searchString || '').toLowerCase())
			);
		},
	},
	data: () => ({
		searchString: '',
	}),
	methods: {
		selectApp(app) {
			this.$emit('select-app', app);
			this.searchString = '';
		},
	},
};
</script>

<style lang="scss" scoped>
.connect_profile {
	background: #fafbfc !important;
	overflow: auto;
	.result_block {
		cursor: pointer;
		transition: all 0.2s;
		border-radius: 10%;
		&:hover {
			background: rgba(0, 0, 0, 0.03);
		}
		h3 {
			font-weight: 400 !important;
			color: #464b57;
		}
	}
}

::v-deep {
	.v-text-field--enclosed .v-input__prepend-inner {
		margin-top: 8px !important;
	}
}
</style>
